import type { SVGProps } from 'react';

export const FavoriteFill = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.845 20.444a1.52 1.52 0 0 1-.57-.361l-1.437-1.306a65.865 65.865 0 0 1-4.748-4.765C3.697 12.452 3 10.782 3 9c0-1.42.478-2.607 1.436-3.564C5.393 4.479 6.58 4 8 4c.806 0 1.603.186 2.39.558.786.372 1.49.975 2.11 1.811.62-.836 1.324-1.44 2.11-1.811A5.542 5.542 0 0 1 17 4c1.42 0 2.607.479 3.564 1.436C21.521 6.393 22 7.58 22 9c0 1.801-.708 3.49-2.125 5.068a63.8 63.8 0 0 1-4.739 4.724l-1.42 1.29a1.511 1.511 0 0 1-.575.362c-.22.077-.437.116-.65.116-.215 0-.43-.039-.646-.116Z" />
    </svg>
  );
};
